export default "__VITE_ASSET__DouaJn6A__"